import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientBeneficiarySaveCitizenshipsMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { SaveCitizenshipParam } from 'api/types/params';

import { parseLegalClientBeneficiaryEntity } from './helpers';

export const useLegalClientBeneficiarySaveCitizenships = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientBeneficiarySaveCitizenshipsMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientBeneficiarySaveCitizenships
      ? parseLegalClientBeneficiaryEntity(
          data.legalClientBeneficiarySaveCitizenships
        )
      : undefined,
    loading,
    error,
    saveCitizenships: useCallback(
      async (
        id: string,
        beneficiaryId: string,
        params: SaveCitizenshipParam
      ) => {
        const res = await handle({
          variables: {
            id,
            beneficiaryId,
            input: params,
          },
        });
        return res?.data?.legalClientBeneficiarySaveCitizenships
          ? parseLegalClientBeneficiaryEntity(
              res.data.legalClientBeneficiarySaveCitizenships
            )
          : undefined;
      },
      [handle]
    ),
  };
};
